<div class="container-fluid login-wrapper">
    <div class="row login-wrapper">
        <div class="col-md-6 d-flex justify-content-center login-bg">
            <div class="login-form">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <p>{{ 'EMAIL_VERIFICATION' | translate }}</p>
                    </div>

                    <div class="panel-body panel-primary">
                        <div class="verification-code">
                            <div *ngIf="!isEmailVerified">
                                <form [formGroup]="form" >
                                  <div class="form-group">
                                      <div class="app-input">
                                          <label for="verificationCodeInput">{{ 'ENTER_VERIFICATION_CODE' | translate }}</label>
                                          <input id="verificationCodeInput" formControlName="verificationCodeInput" type="text" class="form-control" placeholder="{{ 'ENTER_VERIFICATION_CODE' | translate }}" />
                                      </div>
                                       <app-form-error [control]="form.controls.verificationCodeInput"></app-form-error>
                                       <p class="text-danger">{{emailVerificationMessage}}</p>
                                  </div>
                                  <div class="action-container">
                                    
                                      <button class="btn btn-primary btn-login" type="submit" (click)="verifyVerificaitonCode()">
                                          {{ 'OK' | translate }}
                                      </button>
                                       <button class="btn btn-secondary btn-login ml-5" routerLink="/{{ appRoute.Login }}">
                                          {{ 'CANCEL' | translate }}
                                      </button>
                                  </div>
                              </form>
                            </div>
                            <div *ngIf="isEmailVerified" >
                                <h2 class="text-success">{{emailVerificationMessage}}</h2>
                                <div class="action-container">
                                    <button class="btn btn-primary btn-login" routerLink="/{{ appRoute.Login }}">
                                             {{ 'CONTINUE' | translate }}
                                   </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6 login-hero">
            <img class="logo d-none d-md-block" src="assets/images/securly-flex-white.svg" />
            <div class="links"><a href="https://eduspiresolutions.org/terms-of-use">Terms of Use</a> | <a href="https://eduspiresolutions.org/privacy-policy">Privacy Policy</a></div>
        </div>
    </div>
</div>
